export const collections = {
  "posts": {
    "name": "posts",
    "pascalName": "Posts",
    "tableName": "_content_posts",
    "source": [
      {
        "_resolved": true,
        "prefix": "/posts",
        "include": "posts/*.md",
        "cwd": "/home/runner/work/hsinyau.com/hsinyau.com/content"
      }
    ],
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "tag": "string",
      "created": "date",
      "summary": "string"
    },
    "schema": {
      "$ref": "#/definitions/posts",
      "definitions": {
        "posts": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "stem": {
              "type": "string"
            },
            "extension": {
              "type": "string",
              "enum": [
                "md",
                "yaml",
                "yml",
                "json",
                "csv",
                "xml"
              ]
            },
            "meta": {
              "type": "object",
              "additionalProperties": {}
            },
            "path": {
              "type": "string"
            },
            "title": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "seo": {
              "allOf": [
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    }
                  }
                },
                {
                  "type": "object",
                  "additionalProperties": {}
                }
              ],
              "default": {}
            },
            "body": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string"
                },
                "children": {},
                "toc": {}
              },
              "required": [
                "type"
              ],
              "additionalProperties": false
            },
            "navigation": {
              "anyOf": [
                {
                  "type": "boolean"
                },
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    },
                    "icon": {
                      "type": "string"
                    }
                  },
                  "required": [
                    "title",
                    "description",
                    "icon"
                  ],
                  "additionalProperties": false
                }
              ],
              "default": true
            },
            "tag": {
              "type": "string"
            },
            "created": {
              "type": "string",
              "format": "date-time"
            },
            "summary": {
              "type": "string"
            }
          },
          "required": [
            "id",
            "stem",
            "extension",
            "meta",
            "path",
            "title",
            "description",
            "body",
            "tag",
            "created",
            "summary"
          ],
          "additionalProperties": false
        }
      },
      "$schema": "http://json-schema.org/draft-07/schema#"
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_posts (id TEXT PRIMARY KEY, \"title\" VARCHAR, \"body\" TEXT, \"created\" DATE, \"description\" VARCHAR, \"extension\" VARCHAR, \"meta\" TEXT, \"navigation\" TEXT DEFAULT true, \"path\" VARCHAR, \"seo\" TEXT DEFAULT '{}', \"stem\" VARCHAR, \"summary\" VARCHAR, \"tag\" VARCHAR, \"__hash__\" TEXT UNIQUE);"
  },
  "projects": {
    "name": "projects",
    "pascalName": "Projects",
    "tableName": "_content_projects",
    "source": [
      {
        "_resolved": true,
        "prefix": "/projects",
        "include": "projects/*.yml",
        "cwd": "/home/runner/work/hsinyau.com/hsinyau.com/content"
      }
    ],
    "type": "data",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "title": "string",
      "description": "string",
      "color": "string",
      "link": "string",
      "icon": "string"
    },
    "schema": {
      "$ref": "#/definitions/projects",
      "definitions": {
        "projects": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "stem": {
              "type": "string"
            },
            "extension": {
              "type": "string",
              "enum": [
                "md",
                "yaml",
                "yml",
                "json",
                "csv",
                "xml"
              ]
            },
            "meta": {
              "type": "object",
              "additionalProperties": {}
            },
            "title": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "color": {
              "type": "string"
            },
            "link": {
              "type": "string"
            },
            "icon": {
              "type": "string"
            }
          },
          "required": [
            "id",
            "stem",
            "extension",
            "meta",
            "title",
            "description",
            "color",
            "link",
            "icon"
          ],
          "additionalProperties": false
        }
      },
      "$schema": "http://json-schema.org/draft-07/schema#"
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_projects (id TEXT PRIMARY KEY, \"title\" VARCHAR, \"color\" VARCHAR, \"description\" VARCHAR, \"extension\" VARCHAR, \"icon\" VARCHAR, \"link\" VARCHAR, \"meta\" TEXT, \"stem\" VARCHAR, \"__hash__\" TEXT UNIQUE);"
  },
  "friends": {
    "name": "friends",
    "pascalName": "Friends",
    "tableName": "_content_friends",
    "source": [
      {
        "_resolved": true,
        "prefix": "/friends",
        "include": "friends/*.yml",
        "cwd": "/home/runner/work/hsinyau.com/hsinyau.com/content"
      }
    ],
    "type": "data",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "desc": "string",
      "avatar": "string",
      "link": "string"
    },
    "schema": {
      "$ref": "#/definitions/friends",
      "definitions": {
        "friends": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "stem": {
              "type": "string"
            },
            "extension": {
              "type": "string",
              "enum": [
                "md",
                "yaml",
                "yml",
                "json",
                "csv",
                "xml"
              ]
            },
            "meta": {
              "type": "object",
              "additionalProperties": {}
            },
            "name": {
              "type": "string"
            },
            "desc": {
              "type": "string"
            },
            "avatar": {
              "type": "string"
            },
            "link": {
              "type": "string"
            }
          },
          "required": [
            "id",
            "stem",
            "extension",
            "meta",
            "name",
            "desc",
            "avatar",
            "link"
          ],
          "additionalProperties": false
        }
      },
      "$schema": "http://json-schema.org/draft-07/schema#"
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_friends (id TEXT PRIMARY KEY, \"avatar\" VARCHAR, \"desc\" VARCHAR, \"extension\" VARCHAR, \"link\" VARCHAR, \"meta\" TEXT, \"name\" VARCHAR, \"stem\" VARCHAR, \"__hash__\" TEXT UNIQUE);"
  },
  "about": {
    "name": "about",
    "pascalName": "About",
    "tableName": "_content_about",
    "source": [
      {
        "_resolved": true,
        "prefix": "/about",
        "include": "about/*.md",
        "cwd": "/home/runner/work/hsinyau.com/hsinyau.com/content"
      }
    ],
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json"
    },
    "schema": {
      "$ref": "#/definitions/about",
      "definitions": {
        "about": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "stem": {
              "type": "string"
            },
            "extension": {
              "type": "string",
              "enum": [
                "md",
                "yaml",
                "yml",
                "json",
                "csv",
                "xml"
              ]
            },
            "meta": {
              "type": "object",
              "additionalProperties": {}
            },
            "path": {
              "type": "string"
            },
            "title": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "seo": {
              "allOf": [
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    }
                  }
                },
                {
                  "type": "object",
                  "additionalProperties": {}
                }
              ],
              "default": {}
            },
            "body": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string"
                },
                "children": {},
                "toc": {}
              },
              "required": [
                "type"
              ],
              "additionalProperties": false
            },
            "navigation": {
              "anyOf": [
                {
                  "type": "boolean"
                },
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    },
                    "icon": {
                      "type": "string"
                    }
                  },
                  "required": [
                    "title",
                    "description",
                    "icon"
                  ],
                  "additionalProperties": false
                }
              ],
              "default": true
            }
          },
          "required": [
            "id",
            "stem",
            "extension",
            "meta",
            "path",
            "title",
            "description",
            "body"
          ],
          "additionalProperties": false
        }
      },
      "$schema": "http://json-schema.org/draft-07/schema#"
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_about (id TEXT PRIMARY KEY, \"title\" VARCHAR, \"body\" TEXT, \"description\" VARCHAR, \"extension\" VARCHAR, \"meta\" TEXT, \"navigation\" TEXT DEFAULT true, \"path\" VARCHAR, \"seo\" TEXT DEFAULT '{}', \"stem\" VARCHAR, \"__hash__\" TEXT UNIQUE);"
  },
  "media": {
    "name": "media",
    "pascalName": "Media",
    "tableName": "_content_media",
    "source": [
      {
        "_resolved": true,
        "prefix": "/media",
        "include": "media/*.yml",
        "cwd": "/home/runner/work/hsinyau.com/hsinyau.com/content"
      }
    ],
    "type": "data",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "type": "string",
      "items": "json"
    },
    "schema": {
      "$ref": "#/definitions/media",
      "definitions": {
        "media": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "stem": {
              "type": "string"
            },
            "extension": {
              "type": "string",
              "enum": [
                "md",
                "yaml",
                "yml",
                "json",
                "csv",
                "xml"
              ]
            },
            "meta": {
              "type": "object",
              "additionalProperties": {}
            },
            "type": {
              "type": "string",
              "enum": [
                "anime",
                "book",
                "drama",
                "game",
                "movie"
              ]
            },
            "items": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "name": {
                    "type": "string"
                  },
                  "alias": {
                    "type": "string"
                  },
                  "creator": {
                    "type": "string"
                  },
                  "state": {
                    "type": "string",
                    "enum": [
                      "done",
                      "doing",
                      "todo"
                    ]
                  },
                  "date": {
                    "type": "string"
                  },
                  "note": {
                    "type": "string"
                  },
                  "lang": {
                    "type": "string"
                  },
                  "tag": {
                    "type": "string"
                  }
                },
                "required": [
                  "name"
                ],
                "additionalProperties": false
              }
            }
          },
          "required": [
            "id",
            "stem",
            "extension",
            "meta",
            "type",
            "items"
          ],
          "additionalProperties": false
        }
      },
      "$schema": "http://json-schema.org/draft-07/schema#"
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_media (id TEXT PRIMARY KEY, \"extension\" VARCHAR, \"items\" TEXT, \"meta\" TEXT, \"stem\" VARCHAR, \"type\" VARCHAR, \"__hash__\" TEXT UNIQUE);"
  },
  "info": {
    "name": "info",
    "pascalName": "Info",
    "tableName": "_content_info",
    "source": [],
    "type": "data",
    "fields": {},
    "schema": {
      "$ref": "#/definitions/info",
      "definitions": {
        "info": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "version": {
              "type": "string"
            },
            "structureVersion": {
              "type": "string"
            },
            "ready": {
              "type": "boolean"
            }
          },
          "required": [
            "id",
            "version",
            "structureVersion",
            "ready"
          ],
          "additionalProperties": false
        }
      },
      "$schema": "http://json-schema.org/draft-07/schema#"
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_info (id TEXT PRIMARY KEY, \"ready\" BOOLEAN, \"structureVersion\" VARCHAR, \"version\" VARCHAR, \"__hash__\" TEXT UNIQUE);"
  }
}
export const gitInfo = {
  "name": "hsinyau.com",
  "owner": "hsinyau",
  "url": "https://github.com/hsinyau/hsinyau.com"
}
export const appConfigSchema = {
  "properties": {
    "id": "#appConfig",
    "properties": {
      "icon": {
        "title": "Nuxt Icon",
        "description": "Configure Nuxt Icon module preferences.",
        "tags": [
          "@studioIcon material-symbols:star"
        ],
        "id": "#appConfig/icon",
        "properties": {
          "size": {
            "title": "Icon Size",
            "description": "Set the default icon size.",
            "tags": [
              "@studioIcon material-symbols:format-size-rounded"
            ],
            "tsType": "string | undefined",
            "id": "#appConfig/icon/size",
            "default": {},
            "type": "any"
          },
          "class": {
            "title": "CSS Class",
            "description": "Set the default CSS class.",
            "tags": [
              "@studioIcon material-symbols:css"
            ],
            "id": "#appConfig/icon/class",
            "default": "",
            "type": "string"
          },
          "attrs": {
            "title": "Default Attributes",
            "description": "Attributes applied to every icon component.\n\n@default { \"aria-hidden\": true }",
            "tags": [
              "@studioIcon material-symbols:settings"
            ],
            "tsType": "Record<string, string | number | boolean>",
            "id": "#appConfig/icon/attrs",
            "default": {
              "aria-hidden": true
            },
            "type": "object"
          },
          "mode": {
            "title": "Default Rendering Mode",
            "description": "Set the default rendering mode for the icon component",
            "enum": [
              "css",
              "svg"
            ],
            "tags": [
              "@studioIcon material-symbols:move-down-rounded"
            ],
            "id": "#appConfig/icon/mode",
            "default": "css",
            "type": "string"
          },
          "aliases": {
            "title": "Icon aliases",
            "description": "Define Icon aliases to update them easily without code changes.",
            "tags": [
              "@studioIcon material-symbols:star-rounded"
            ],
            "tsType": "{ [alias: string]: string }",
            "id": "#appConfig/icon/aliases",
            "default": {},
            "type": "object"
          },
          "cssSelectorPrefix": {
            "title": "CSS Selector Prefix",
            "description": "Set the default CSS selector prefix.",
            "tags": [
              "@studioIcon material-symbols:format-textdirection-l-to-r"
            ],
            "id": "#appConfig/icon/cssSelectorPrefix",
            "default": "i-",
            "type": "string"
          },
          "cssLayer": {
            "title": "CSS Layer Name",
            "description": "Set the default CSS `@layer` name.",
            "tags": [
              "@studioIcon material-symbols:layers"
            ],
            "tsType": "string | undefined",
            "id": "#appConfig/icon/cssLayer",
            "default": {},
            "type": "any"
          },
          "cssWherePseudo": {
            "title": "Use CSS `:where()` Pseudo Selector",
            "description": "Use CSS `:where()` pseudo selector to reduce specificity.",
            "tags": [
              "@studioIcon material-symbols:low-priority"
            ],
            "id": "#appConfig/icon/cssWherePseudo",
            "default": true,
            "type": "boolean"
          },
          "collections": {
            "title": "Icon Collections",
            "description": "List of known icon collections name. Used to resolve collection name ambiguity.\ne.g. `simple-icons-github` -> `simple-icons:github` instead of `simple:icons-github`\n\nWhen not provided, will use the full Iconify collection list.",
            "tags": [
              "@studioIcon material-symbols:format-list-bulleted"
            ],
            "tsType": "string[] | null",
            "id": "#appConfig/icon/collections",
            "default": null,
            "type": "any"
          },
          "customCollections": {
            "title": "Custom Icon Collections",
            "tags": [
              "@studioIcon material-symbols:format-list-bulleted"
            ],
            "tsType": "string[] | null",
            "id": "#appConfig/icon/customCollections",
            "default": null,
            "type": "any"
          },
          "provider": {
            "title": "Icon Provider",
            "description": "Provider to use for fetching icons\n\n- `server` - Fetch icons with a server handler\n- `iconify` - Fetch icons with Iconify API, purely client-side\n\n`server` by default; `iconify` when `ssr: false`",
            "enum": [
              "server",
              "iconify"
            ],
            "tags": [
              "@studioIcon material-symbols:cloud"
            ],
            "type": "\"server\" | \"iconify\" | undefined",
            "id": "#appConfig/icon/provider"
          },
          "iconifyApiEndpoint": {
            "title": "Iconify API Endpoint URL",
            "description": "Define a custom Iconify API endpoint URL. Useful if you want to use a self-hosted Iconify API. Learn more: https://iconify.design/docs/api.",
            "tags": [
              "@studioIcon material-symbols:api"
            ],
            "id": "#appConfig/icon/iconifyApiEndpoint",
            "default": "https://api.iconify.design",
            "type": "string"
          },
          "fallbackToApi": {
            "title": "Fallback to Iconify API",
            "description": "Fallback to Iconify API if server provider fails to found the collection.",
            "tags": [
              "@studioIcon material-symbols:public"
            ],
            "enum": [
              true,
              false,
              "server-only",
              "client-only"
            ],
            "type": "boolean | \"server-only\" | \"client-only\"",
            "id": "#appConfig/icon/fallbackToApi",
            "default": true
          },
          "localApiEndpoint": {
            "title": "Local API Endpoint Path",
            "description": "Define a custom path for the local API endpoint.",
            "tags": [
              "@studioIcon material-symbols:api"
            ],
            "id": "#appConfig/icon/localApiEndpoint",
            "default": "/api/_nuxt_icon",
            "type": "string"
          },
          "fetchTimeout": {
            "title": "Fetch Timeout",
            "description": "Set the timeout for fetching icons.",
            "tags": [
              "@studioIcon material-symbols:timer"
            ],
            "id": "#appConfig/icon/fetchTimeout",
            "default": 1500,
            "type": "number"
          },
          "customize": {
            "title": "Customize callback",
            "description": "Customize icon content (replace stroke-width, colors, etc...).",
            "tags": [
              "@studioIcon material-symbols:edit"
            ],
            "type": "IconifyIconCustomizeCallback",
            "id": "#appConfig/icon/customize"
          }
        },
        "type": "object",
        "default": {
          "size": {},
          "class": "",
          "attrs": {
            "aria-hidden": true
          },
          "mode": "css",
          "aliases": {},
          "cssSelectorPrefix": "i-",
          "cssLayer": {},
          "cssWherePseudo": true,
          "collections": null,
          "customCollections": null,
          "iconifyApiEndpoint": "https://api.iconify.design",
          "fallbackToApi": true,
          "localApiEndpoint": "/api/_nuxt_icon",
          "fetchTimeout": 1500
        }
      },
      "site": {
        "title": "站点信息",
        "description": "站点的一些基本信息~",
        "tags": [
          "@previewIcon i-ph-aperture-duotone"
        ],
        "id": "#appConfig/site",
        "properties": {
          "name": {
            "type": "string",
            "title": "Site Name",
            "description": "站点名字",
            "tags": [
              "@previewInput string",
              "@previewIcon i-ph-address-book-duotone"
            ],
            "id": "#appConfig/site/name"
          },
          "description": {
            "type": "string",
            "title": "Description",
            "description": "站点描述",
            "tags": [
              "@previewInput string",
              "@previewIcon i-ph-sort-descending-fill"
            ],
            "id": "#appConfig/site/description"
          },
          "author": {
            "type": "string",
            "title": "Author",
            "description": "作者",
            "tags": [
              "@previewInput string",
              "@previewIcon i-ph-user-check-duotone"
            ],
            "id": "#appConfig/site/author"
          },
          "domain": {
            "type": "string",
            "title": "Domain",
            "description": "域名",
            "tags": [
              "@previewInput string",
              "@previewIcon i-ph-link-simple-break-duotone"
            ],
            "id": "#appConfig/site/domain"
          },
          "avatar": {
            "type": "string",
            "title": "Avatar",
            "description": "头像",
            "tags": [
              "@previewInput string",
              "@previewIcon i-ph-camera-duotone"
            ],
            "id": "#appConfig/site/avatar"
          }
        },
        "type": "object",
        "default": {}
      },
      "menu": {
        "title": "菜单",
        "description": "页面顶部菜单",
        "menu": {
          "$schema": {
            "type": "array",
            "title": "Menu",
            "description": "页面顶部菜单中显示的链接对象数组",
            "default": [],
            "tags": [
              "@previewInput array",
              "@previewIcon i-ph-link-simple-break-duotone"
            ]
          }
        },
        "tags": [
          "@previewIcon i-ph-list-bullets-duotone"
        ],
        "id": "#appConfig/menu",
        "type": "any",
        "default": {}
      },
      "sub_nav": {
        "title": "子菜单",
        "description": "页面中显示的二级菜单",
        "sub_nav": {
          "$schema": {
            "type": "array",
            "title": "Sub Nav",
            "description": "页面二级菜单中显示的链接对象数组",
            "default": [],
            "tags": [
              "@previewInput array",
              "@previewIcon i-ph-link-simple-break-duotone"
            ]
          }
        },
        "tags": [
          "@previewIcon i-ph-list-bullets-duotone"
        ],
        "id": "#appConfig/sub_nav",
        "type": "any",
        "default": {}
      },
      "hero": {
        "title": "Hero",
        "description": "首页显示的 Hero 内容",
        "hero": {
          "$schema": {
            "type": "array",
            "title": "Hero",
            "description": "首页 Hero 中显示的链接对象数组",
            "default": [],
            "tags": [
              "@previewInput array",
              "@previewIcon i-ph-link-simple-break-duotone"
            ]
          }
        },
        "tags": [
          "@previewIcon i-ph-list-bullets-duotone"
        ],
        "id": "#appConfig/hero",
        "type": "any",
        "default": {}
      },
      "socials": {
        "title": "Socials",
        "description": "社交媒体链接",
        "socials": {
          "$schema": {
            "type": "array",
            "title": "Socials",
            "description": "社交媒体的链接对象数组",
            "default": [],
            "tags": [
              "@previewInput array",
              "@previewIcon i-ph-link-simple-break-duotone"
            ]
          }
        },
        "tags": [
          "@previewIcon i-ph-list-bullets-duotone"
        ],
        "id": "#appConfig/socials",
        "type": "any",
        "default": {}
      }
    },
    "type": "object",
    "default": {
      "icon": {
        "size": {},
        "class": "",
        "attrs": {
          "aria-hidden": true
        },
        "mode": "css",
        "aliases": {},
        "cssSelectorPrefix": "i-",
        "cssLayer": {},
        "cssWherePseudo": true,
        "collections": null,
        "customCollections": null,
        "iconifyApiEndpoint": "https://api.iconify.design",
        "fallbackToApi": true,
        "localApiEndpoint": "/api/_nuxt_icon",
        "fetchTimeout": 1500
      },
      "site": {},
      "menu": {},
      "sub_nav": {},
      "hero": {},
      "socials": {}
    }
  },
  "default": {
    "icon": {
      "size": {},
      "class": "",
      "attrs": {
        "aria-hidden": true
      },
      "mode": "css",
      "aliases": {},
      "cssSelectorPrefix": "i-",
      "cssLayer": {},
      "cssWherePseudo": true,
      "collections": null,
      "customCollections": null,
      "iconifyApiEndpoint": "https://api.iconify.design",
      "fallbackToApi": true,
      "localApiEndpoint": "/api/_nuxt_icon",
      "fetchTimeout": 1500
    },
    "site": {},
    "menu": {},
    "sub_nav": {},
    "hero": {},
    "socials": {}
  }
}